// extracted by mini-css-extract-plugin
export default {"Container":"Morals_Container__5jA51","Header":"Morals_Header__5G1GI","Img":"Morals_Img__8+GaU","p":"Morals_p__PCwWo","h2":"Morals_h2__f7rlL"};